// extracted by mini-css-extract-plugin
export default {"comment-button":"CriteriaComment_comment-button__MKP-4","footer":"CriteriaComment_footer__BGGyK"};